import { render, staticRenderFns } from "./p3s4AccountSetupCreateLocation.vue?vue&type=template&id=34a5caee"
import script from "./p3s4AccountSetupCreateLocation.vue?vue&type=script&lang=js"
export * from "./p3s4AccountSetupCreateLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports